export const toPx = (s: string | number) => (s.toString().endsWith('px') ? s : s + 'px')
